export const LockIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M10 1C12.4853 1 14.5 3.01472 14.5 5.5V9H15C16.1046 9 17 9.89543 17 11V17C17 18.1046 16.1046 19 15 19H5C3.89543 19 3 18.1046 3 17V11C3 9.89543 3.89543 9 5 9H5.5V5.5C5.5 3.01472 7.51472 1 10 1ZM10 2.5C8.34315 2.5 7 3.84315 7 5.5V9H13V5.5C13 3.84315 11.6569 2.5 10 2.5Z"
      fill="currentColor"
    />
  </svg>
);
